import React, { useState, useRef } from "react";
import { Tabs, Button, Space, message, Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import MyProfile from "./MyProfile";
import CompanyProfile from "./CompanyProfile";
import ChangePassword from "./ChangePassword";
import { REDUX as REDUX_UTIL, TIME } from "../../../../services/util";

const { reduxStoreWrapper } = REDUX_UTIL;

// Actions
import * as REDUX_ACTION from "../../../../services/redux/actions";

import * as ACTIONS from "../../../../services/redux/actions";

const ProfilePage = () => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const [isEditing, setIsEditing] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("1");
  const [loading, setLoading] = useState(false);
  const companyFormRef = useRef(null);
  const [messageApi, contextHolder] = message.useMessage();
  const [passwordData, setPasswordData] = useState({
    currentPwd: "",
    newPassword: "",
    confirmPwd: "",
  });

  const user = useSelector(reduxStoreWrapper("user"));
  const isAdmin = user.uroleid === "A";

  const onChange = (key) => {
    setActiveTabKey(key);
    setIsEditing(false);
  };

  const items = [
    {
      key: "1",
      label: "My Profile",
      children: <MyProfile form={form} isEditing={isEditing} />,
    },
    {
      key: "2",
      label: "Company Profile",
      children: <CompanyProfile form={form} isEditing={isEditing} />,
    },
    {
      key: "3",
      label: "Change Password",
      children: (
        <ChangePassword
          setPasswordData={setPasswordData}
          isEditing={isEditing}
        />
      ),
    },
  ].filter((item) => !(isAdmin && item.key === "2"));

  const toggleEditMode = () => {
    setIsEditing(!isEditing);
  };

  const saveProfile = () => {
    form.validateFields().then((value) => {
      const { contactCode, contactNumber } = value;
      const formValues = {
        ...value,
        contact: contactCode + contactNumber,
      };
      setLoading(true);

      delete formValues.contactCode;
      delete formValues.contactNumber;

      messageApi.open({
        type: "loading",
        content: `Updating user profile...`,
        duration: 0,
      });

      dispatch(
        REDUX_ACTION.v1_user.user_update_data_request(
          {
            uid: user.uid,
            items: { ...formValues, uroleid: user.roleId },
            updatedBy: user.uid,
          },
          () => messageApi.destroy()
        )
      );
      setIsEditing(false);
    });
  };

  const saveCompany = () => {
    form.validateFields().then((value) => {
      const { pic } = value;
      const mixContact = pic.contactCode + pic.contactNumber;

      const companyData = {
        items: {
          ...value,
          pic: {
            ...pic,
            contact: mixContact,
          },
        },
        coid: user.coid,
        updatedBy: user.memid,
      };
      delete companyData.items.pic.contactCode;
      delete companyData.items.pic.contactNumber;

      setLoading(true);

      messageApi.open({
        type: "loading",
        content: `Updating user profile...`,
        duration: 0,
      });

      dispatch(
        REDUX_ACTION.v1_company.update_company_request(companyData, () => {
          messageApi.destroy();
        })
      );

      setIsEditing(false);
    });
  };

  const savePassword = () => {
    const { pwd, currentPwd } = passwordData;

    messageApi.open({
      type: "loading",
      content: "Changing the password...",
      duration: 0,
    });

    dispatch(
      ACTIONS.v1_user.user_change_password_request(
        user.email,
        currentPwd,
        pwd,
        ({ status }) => {
          if (status === 200) {
            messageApi.destroy();
            message.success("Your password has been successfully changed");
          } else if (status === 404) {
            messageApi.destroy();
            message.error(
              "Current password is input wrong. So, change password action is voided!"
            );
          } else {
            message.error("Failed to change password!");
          }
        }
      )
    );
  };

  const cancelEdit = () => {
    setIsEditing(false);
  };

  const saveChanges = () => {
    if (activeTabKey === "1") {
      saveProfile();
    } else if (activeTabKey === "2") {
      saveCompany();
    } else if (activeTabKey === "3") {
      savePassword();
    }
  };

  const operations = isEditing ? (
    <Space>
      <Button type="primary" onClick={saveChanges}>
        Save
      </Button>
      <Button onClick={cancelEdit}>Cancel</Button>
    </Space>
  ) : (
    <Button type="primary" onClick={toggleEditMode}>
      {activeTabKey === "3" ? "Edit Password" : "Edit Profile"}
    </Button>
  );

  return (
    <>
      {contextHolder}
      <div style={{ width: "64rem", padding: "3em" }}>
        <Tabs
          defaultActiveKey="1"
          items={items}
          onChange={onChange}
          tabBarExtraContent={operations}
        />
      </div>
    </>
  );
};

export default ProfilePage;
